import { CheckboxClassKey } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';

/* ******************************************************  Override  ****************************************************** */
export const CustomCheckbox: Partial<OverridesStyleRules<CheckboxClassKey>> | undefined = {
  root: {},
};
